<script setup lang="ts">
import Curriculum from '@/components/layout/Curriculum/Curriculum.vue'
import { getCvVariant } from '@/utils/cvVariant'

const isAnthropicCv = getCvVariant() === 'anthropic'

if (isAnthropicCv) {
  document.title = 'Jonathan Ruiz — Developer Productivity & CI/CD'
}
</script>

<template>
  <div
    id="app"
    class="min-h-screen bg-slate-100 text-slate-900 dark:bg-slate-950 dark:text-slate-100"
    :class="{ 'anthropic-cv': isAnthropicCv }"
  >
    <a
      href="#work-experience"
      class="sr-only z-[200] rounded bg-white px-4 py-2 text-slate-950 focus:not-sr-only focus:fixed focus:left-4 focus:top-4"
    >
      Skip to work experience
    </a>
    <main class="mx-auto max-w-6xl px-0 py-0 sm:px-4 sm:py-8 lg:py-12">
      <Curriculum />
    </main>
  </div>
</template>

<style>
/* Global styles are imported in main.ts */
</style>
